import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PartyEditFormImpl from './PartyEditFormImpl';
import PartyList from './PartyList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PartyListView from './PartyListView'


export default function PartyDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.partyDashboard);
  const [ partyId, setPartyId] = React.useState('');
  const [reloadPartyList, setReloadPartyList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PartyEditFormImpl 
            setReloadPartyList={setReloadPartyList}
            partyId={partyId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PartyListView 
                      setPartyId = {setPartyId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
